import { Injectable } from '@angular/core';
import { ChatChannelConfigPayload, SearchUserParams } from '@app/domain';
import { ChatSettingsRepository } from '@app/domain/repositories/chat-settings.repository';
import { map, Observable } from 'rxjs';
import { ChatSettingsService } from '../api-clients/chat-settings.service';
import { ChatSettingsMapper } from '../mappers/chat-settings.mapper';

@Injectable()
export class ChatSettingsRepositoryImpl implements ChatSettingsRepository {
  private readonly _chatSettingsMapper = new ChatSettingsMapper();

  constructor(private readonly _chatSettingsService: ChatSettingsService) {}

  getAllChatType(): Observable<any> {
    const allChatType = this._chatSettingsService.getAllChatType();
    return allChatType.pipe(
      map(dto => this._chatSettingsMapper.getAllChatTypeToDomain(dto))
    );
  }

  getApplicableSector(chatTypeId: number, queryParams: any): Observable<any> {
    const applicableSector = this._chatSettingsService.getApplicableSector(
      chatTypeId,
      queryParams
    );
    return applicableSector.pipe(
      map(dto => this._chatSettingsMapper.getApplicableSectorToDomain(dto))
    );
  }

  getChatChannelConfig(): Observable<any> {
    const chatChannelConfig = this._chatSettingsService.getChatChannelConfig();
    return chatChannelConfig.pipe(
      map(dto => this._chatSettingsMapper.getChatChannelConfigToDomain(dto))
    );
  }

  updateChatChannelConfig(config: ChatChannelConfigPayload): Observable<any> {
    const updatedChatChannelConfig =
      this._chatSettingsService.updateChatChannelConfig(config);
    return updatedChatChannelConfig.pipe(
      map(dto => this._chatSettingsMapper.updateChatChannelConfigToDomain(dto))
    );
  }

  getConfigDetail(): Observable<any> {
    const configDetail = this._chatSettingsService.getConfigDetail();
    return configDetail.pipe(
      map(dto => this._chatSettingsMapper.getConfigDetailToDomain(dto))
    );
  }

  updateConfig(config: any): Observable<any> {
    const updatedConfig = this._chatSettingsService.updateConfig(config);
    return updatedConfig.pipe(
      map(dto => this._chatSettingsMapper.updateConfigToDomain(dto))
    );
  }

  getArchivedSectors(queryParams: any): Observable<any> {
    const archivedSectors =
      this._chatSettingsService.getArchivedSectors(queryParams);
    return archivedSectors.pipe(
      map(dto => this._chatSettingsMapper.getArchivedSectorsToDomain(dto))
    );
  }

  switchArchiveSector(sectorId: number, sectorName: string): Observable<any> {
    const switchedArchiveSector = this._chatSettingsService.switchArchiveSector(
      sectorId,
      sectorName
    );
    return switchedArchiveSector.pipe(
      map(dto => this._chatSettingsMapper.switchArchiveSectorToDomain(dto))
    );
  }

  searchUser(queryParams: SearchUserParams): Observable<any> {
    const searchedUser = this._chatSettingsService.searchUser(queryParams);
    return searchedUser.pipe(
      map(dto => this._chatSettingsMapper.searchUserToDomain(dto))
    );
  }

  getChatSettings(): Observable<any> {
    const searchedUser = this._chatSettingsService.getChatSettings();
    return searchedUser.pipe(
      map(dto => this._chatSettingsMapper.chatSettingsToDomain(dto))
    );
  }

  updateChatSettings(chatChannelConfig: any, chatConfig: any): Observable<any> {
    const searchedUser = this._chatSettingsService.updateChatSettings(
      chatChannelConfig,
      chatConfig
    );
    return searchedUser.pipe(
      map(dto => this._chatSettingsMapper.chatSettingsToDomain(dto))
    );
  }
}
